var React = require('react');

function IconChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 13L7 7L1 1"}));
}

IconChevron.defaultProps = {"viewBox":"0 0 9 14","fill":"none"};

module.exports = IconChevron;

IconChevron.default = IconChevron;
